import { AlarmTriggerLogicControls } from './AlarmTriggerLogicControls';

export function AlarmTriggerLogicStep() {
  return (
    <div className='flex flex-col gap-6 px-4 py-4 md:px-6'>
      <AlarmTriggerLogicControls />
    </div>
  );
}
